import { IS_DEVELOPMENT } from './isDevelopment'

const DEV_ZERVANT_BASE_URL = 'https://api.staging.billy.dk/invoicing'

export const getZervantBaseURL = (): string => {
  if (
    typeof window !== 'undefined' &&
    typeof window.ENV !== 'undefined' &&
    typeof window.ENV.ZERVANT_URL !== 'undefined'
  ) {
    return window.ENV.ZERVANT_URL
  }

  return IS_DEVELOPMENT ? DEV_ZERVANT_BASE_URL : ''
}
